// extracted by mini-css-extract-plugin
export default {"itemWrapper":"_84b388e9","swiperItem":"_49001090","itemInner":"_f33683e4","heartButton":"_67695a73","heart":"_824ee765","swiperWrapper":"_f4c4a336"};